// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__33AaB","modalForm":"UpgradeEpcsModal_modalForm__27fDe","modalFooter":"UpgradeEpcsModal_modalFooter__2qcu6"};